import React, { useEffect, useRef } from "react";
import TypingEffect from "./TypingEffect";
import { getFileTypeLabel } from "../../Functions/Utils";
import ChatbotSkeleton from "./ChatbotSkeleton";

function ChatWrapper({
  children,
  type,
  hasAttachment,
  chatMessages,
  InitialText,
  setIsTyping,
  isLoading
}) {
  const chatEndRef = useRef();
  const scrollToBottom = () => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  useEffect(() => {
    scrollToBottom();
  }, [chatMessages]);
  

  return type == "single" ? (
    <>
      <div className="w-100 h-100 d-flex">
        <div className="p-3 p-lg-5 m-auto max_w_600x">
          <h6 className="fw_600 h5 text-center pb-2">
            How can I assist you today?
          </h6>
          <p
            className="text_gray8 font_13 pb-2"
            style={{ textAlign: "justify" }}
          >
            {InitialText}
          </p>
          {children}
        </div>
      </div>
    </>
  ) : (
    <div className="d-flex h-100 p-2 pb-0 w-100">
      <div className="h-100 overflow-auto pt-2 px-3 w-100 scrollbar1">
        <div style={{ maxWidth: 860, margin: "auto" }}>
          <div
            className={
              hasAttachment
                ? `chat__messages pt-5 has__attachment`
                : `chat__messages pt-5`
            }
          >
            <ul className="list-unstyled d-grid gap-3 gap-md-4">
              {chatMessages.map((chat, index) => (
                <li key={index}>
                  {/* Conditionally render the user avatar only for bot messages */}
                  {chat.isBot ? (
                    <div
                      className="p-3 pb-1 rounded-4 d-inline-flex flex-column"
                      style={{ background: "rgb(241, 243, 245)" }}
                    >
                      <h6 className="fw_600">Answer</h6>
                      {chat.useTypingEffect && (
                        <TypingEffect
                          text={chat.text}
                          delay={100}
                          setIsTyping={setIsTyping}
                        />
                      )}
                    </div>
                  ) : (
                    <div className="d-flex gap-2">
                      <div
                        className="border circle_45x d-flex rounded-circle"
                        style={{ flex: "none" }}
                      >
                        <i className="fas fa-user-alt m-auto"></i>
                      </div>
                      <div
                        className="border font_13 rounded-4 text_dark_gray"
                        style={{
                          padding: "12px",
                          // backgroundColor:"rgb(241 243 245)",
                          minWidth: "25%",
                        }}
                      >
                        {chat.text && <p className="mb-0">{chat.text}</p>}

                        {chat.audio && (
                          <audio
                            controls
                            src={chat.audio}
                            style={{ marginTop: 10 }}
                          ></audio>
                        )}
                        {chat.attachments?.length > 0 && (
                          <div className="d-flex gap-2 mt-2 flex-wrap">
                            {chat.attachments.map((item) => {
                              return item.UploadedInputFileType.startsWith(
                                "image/"
                              ) ? (
                                <img
                                  src={item.UploadedInputFile}
                                  className="bg_gray15 border object-fit-cover rounded"
                                  style={{ height: 65, width: 100 }}
                                />
                              ) : (
                                <div className="bg_gray15 d-flex gap-2 p-2 rounded align-items-center max_w_200x">
                                  <span>
                                    <i
                                      className="far fa-file-alt font_18 rounded-1 text-bg-danger"
                                      style={{ padding: 12 }}
                                    ></i>
                                  </span>
                                  <div>
                                    <p
                                      className="font_12 fw_500 lh-sm line_control_1 max_w_110x mb-0 min_w_80x overflow-hidden w-100 pe-2"
                                      title={item.UploadedInputFileName}
                                    >
                                      {item.UploadedInputFileName}
                                    </p>
                                    <span className="font_10 lh-1 d-inline-block line_control_1 max_w_100x overflow-hidden">
                                      {getFileTypeLabel(
                                        item.UploadedInputFileType
                                      )}
                                    </span>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </li>
              ))}
            </ul>
            {isLoading &&
              <ChatbotSkeleton/>
            }
          </div>
          <div ref={chatEndRef} />
          <div className="bg-white bottom-0 chat-input pb-3 position-sticky pt-2">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChatWrapper;
